import React from 'react'
import ReportCallDetailItem from "./ReportCallDetailItem"

const ReportCallDetailBody = (props) => {
    const {error, listReports} = props

    return (
        <tbody className="CustomersBody">
        {
            !!listReports && listReports.length > 0 ? listReports.map((item, index) => (
                <ReportCallDetailItem key={index} item={item} index={index}/>
            )) : <tr className="NoRecord">
                <td colSpan={7}>Không có bản ghi nào.</td>
            </tr>
        }

        {
            !!error && error.length > 0 && <tr className="NoRecord Error">
                <td colSpan={7}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default ReportCallDetailBody
